import React, {useState} from 'react';
import {connect} from "react-redux";
import EmergencyContactForm from '~/Components/Forms/EmergencyContactForm/EmergencyContactForm';
import {
    updateGuestForm,
    saveGuestEmergencyContact,
    nextStepAction, prevStepAction
} from "~/redux/actions/guests";
import StepsNavigation from '../StepsNavigation';

const EmergencyContact = ({guests, formData, activeGuest, activeStep, ...props}) => {

    const [error, setError] = useState(null);

    const guest = guests[activeGuest];

    const updateForm = (form) => {
        props.dispatch(updateGuestForm(form));
    }

    if (!guest) {
        return <></>;
    }

    const step = activeStep[activeGuest];
    const form = formData[activeGuest][step]

    const handlePrevious = () => {
        props.dispatch(prevStepAction());
    }

    const handleNext = () => {
        let promise = props.dispatch(saveGuestEmergencyContact(guest.id, form));

        promise.then((data) => {
            setError(null);

            props.dispatch(nextStepAction());

        }).catch(error => setError(error.data));
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    {error?.message && (
                        <div className="alert alert-danger" role="alert">
                            {error.message}
                        </div>
                    )}

                    <EmergencyContactForm errors={error?.errors} values={form} onChange={updateForm}/>
                </div>
            </div>

            <StepsNavigation
                fnPrevious={handlePrevious}
                fnNext={handleNext}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    guests: state.guests?.list,
    activeGuest: state.guests?.activeGuest,
    activeStep: state.guests?.activeStep,
    formData: state.guests?.formData
});

export default connect(mapStateToProps)(EmergencyContact);
